// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-module_footer-nLbIX {
  display: flex;
}
.styles-module_footer-nLbIX p {
  margin-right: 0.625rem;
}
`, "",{"version":3,"sources":["webpack://./../components/src/utils/hooks/useNotification/styles.module.less"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AAFA;EAIQ,sBAAA;AACR","sourcesContent":[".footer {\n    display: flex;\n\n    p {\n        margin-right: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `styles-module_footer-nLbIX`
};
export default ___CSS_LOADER_EXPORT___;
